module.exports = __webpack_public_path__ + "assets/85d24a2e0143bee55dea475db6add8c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/bg4.png
// module id = 383
// module chunks = 1